export default __webpack_public_path__ + "static/media/icons8-foundation.5925e4c7.svg";